import styled from 'styled-components';

export const Container = styled.div`
  ant-modal-footer {
  margin-top: 0 !important;
}
`;
